import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    // OTIMIZAÇÃO: Verificação segura para evitar conflito com parcelamento
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const cta = document.querySelector('shopify-payment-terms')?.shadowRoot?.querySelector('#shopify-installments-cta');
      // Uso de Arrow Function para garantir o contexto do 'this'
      cta?.addEventListener('click', () => this.closeDialog(), { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}